import { createSlice } from "@reduxjs/toolkit";

const userOrganizationsSlice = createSlice({
  name: "userOrganizations",
  initialState: {
    organizations: [],
    loading: false,
    error: null,
  },
  reducers: {
    setUserOrganizations: (state, action) => {
      state.organizations = Array.isArray(action.payload)
        ? action.payload
        : Array.isArray(action.payload?.data)
        ? action.payload.data
        : [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const { setUserOrganizations } = userOrganizationsSlice.actions;
export default userOrganizationsSlice.reducer;
